import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private modalService: NgbModal, private toastr: ToastrService) { }

  public open(content: any, options: any = {}): NgbModalRef {
    return this.modalService.open(content, options);
  }

  showSuccess(title: string, text: string): void {
    this.toastr.success(text, title);
  }

  showWarn(title: string, text: string): void {
    this.toastr.warning(text, title);
  }
}
